import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/sales";
const options = {role: ROLE.RESTAURANT};

export const transactionList = async (values) => {
    return await axiosInstance(options).post(`${path}/transaction-list`, values);
}

export const transactionDetail = async (_id) => {
    return await axiosInstance(options).post(`${path}/transaction-details`, _id);
}


export const orderList = async (values) => {
    return await axiosInstance(options).post(`${path}/order-list`, values);
}

export const orderDetail = async (_id) => {
    return await axiosInstance(options).get(`${path}/order-details?order_id=${_id}`);
}